/**
 * @generated SignedSource<<80e98a3c8752218ed1f1890fd447c889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AssessmentReportDetailType = "NOT_PASSED" | "PASSED" | "TOTAL" | "%future added value";
export type StudentSkillAssessmentsReportDetailFilterInput = {
  assessmentReportDetailType: AssessmentReportDetailType;
  reportFromDate: any;
  reportToDate: any;
  userId: string;
};
export type DashboardSkillAssessmentReportDetalQuery$variables = {
  filter: StudentSkillAssessmentsReportDetailFilterInput;
};
export type DashboardSkillAssessmentReportDetalQuery$data = {
  readonly studentSkillAssessmentsReportDetail: ReadonlyArray<{
    readonly assessmentCount: number;
    readonly skillCode: string;
    readonly skillId: number;
    readonly skillName: string;
  }>;
};
export type DashboardSkillAssessmentReportDetalQuery = {
  response: DashboardSkillAssessmentReportDetalQuery$data;
  variables: DashboardSkillAssessmentReportDetalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentSkillAssessmentsReportDetail",
    "kind": "LinkedField",
    "name": "studentSkillAssessmentsReportDetail",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assessmentCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "skillName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardSkillAssessmentReportDetalQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardSkillAssessmentReportDetalQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "374d5beb361992d787ad7645d6effd3a",
    "id": null,
    "metadata": {},
    "name": "DashboardSkillAssessmentReportDetalQuery",
    "operationKind": "query",
    "text": "query DashboardSkillAssessmentReportDetalQuery(\n  $filter: StudentSkillAssessmentsReportDetailFilterInput!\n) {\n  studentSkillAssessmentsReportDetail(filter: $filter) {\n    assessmentCount\n    skillCode\n    skillId\n    skillName\n  }\n}\n"
  }
};
})();

(node as any).hash = "a63b973987fec85a1da20154609e3a01";

export default node;
